import Resource from './common/resource';

class Tags extends Resource {
  path = 'tags';
}

export default Tags;
